import { CHECKBOX_COLUMN } from '../../shared/utils/consts';
import { getTableMinWidth } from '../../shared/utils/styles';
import type { OpenXAgentTableColumn } from '../../shared/utils/types';
import type { SortAccessors } from '../../shared/utils/useSorting';
import type { OpenXAgentMatchedSegment } from './types';

export const ALL_DATA_PARTNERS = '';

const NAME_COLUMN_MIN_WIDTH = 240;

// fixed widths fit each header title plus its 20px sort arrow
export const TABLE_COLUMNS: OpenXAgentTableColumn[] = [
  CHECKBOX_COLUMN,
  { id: 'name', width: 'auto' },
  { id: 'description', width: '220px' },
  { id: 'category', width: '140px' },
  { id: 'dataPartner', width: '140px' },
  { id: 'price', width: '114px' },
  { id: 'uniqueUsers', width: '144px' },
  { id: 'ctvDevices', width: '144px' },
  { id: 'activeIps', width: '126px' },
  { id: 'mobileDevices', width: '158px' },
];

export const TABLE_MIN_WIDTH = getTableMinWidth(TABLE_COLUMNS, NAME_COLUMN_MIN_WIDTH);

// price sorts by fixed CPM; partners priced only by % of media go last
export const SORT_ACCESSORS: SortAccessors<OpenXAgentMatchedSegment> = {
  name: ({ name }) => name,
  description: ({ description }) => description,
  category: ({ category }) => category,
  dataPartner: ({ dataPartner }) => dataPartner,
  price: ({ price }) => price.fixedCpm,
  uniqueUsers: ({ uniqueUsers }) => uniqueUsers,
  ctvDevices: ({ ctvDevices }) => ctvDevices,
  activeIps: ({ activeIps }) => activeIps,
  mobileDevices: ({ mobileDevices }) => mobileDevices,
};
